import {performHttpRequest} from "@/http/http";

export async function postSession(id, data) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/auth/user/session/' + id,
        'POST',
        data
    )
}

export async function setSessionDefault(id, type = 'enable') {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/auth/user/session/' + id + '/default/' + type,
        'PUT'
    )
}

export async function deleteUserSession(id) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/auth/user/session/' + id,
        'DELETE'
    )
}

export async function postUserSession(data) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/auth/user/session',
        'POST',
        data
    )
}
